<app-auth-layout
    art="unknown"
  headline="Customer Portal"
  blurb="We couldn't find an organization at this address. Enter your organization's portal
         address and we'll take you there."
  [tags]="['Unknown address']"
>
  <h1 class="fallback__title">Sign in</h1>

  @if (attempted !== '') {
    <p class="fallback__attempted">
      There's no organization at <b>{{ attempted }}.{{ baseHost }}</b>.
    </p>
  }

  <form class="fallback__form" (submit)="go($event)">
    <label class="fallback__label" for="portal-address">Your organization's address</label>

    <input
      id="portal-address"
      class="fallback__input"
      type="text"
      name="portal-address"
      placeholder="your-company"
      autocomplete="off"
      autocapitalize="off"
      spellcheck="false"
      [class.fallback__input--invalid]="invalid()"
      [attr.aria-invalid]="invalid()"
      [attr.aria-describedby]="invalid() ? 'portal-address-error' : 'portal-address-hint'"
      [value]="entered()"
      (input)="onInput($event)"
    />

    @if (invalid()) {
      <p class="fallback__error" id="portal-address-error" role="alert">
        Use just the first part of the address — letters, numbers and hyphens.
      </p>
    } @else {
      <p class="fallback__hint" id="portal-address-hint">
        <span class="fallback__hint-slug">{{ slug() ?? 'your-company' }}</span
        >.{{ baseHost }}
      </p>
    }

    <button type="submit" class="fallback__continue" [disabled]="slug() === null">
      Continue
    </button>
  </form>

  <div class="fallback__or"><span>or</span></div>

  <!-- Secondary, and a navigation rather than a login: this screen only ever
       renders on a customer host, whose provider is Auth0 — which refuses to
       start a login for a slug with no organization. Staff need the apex door.
       See buildStaffDoorUrl. -->
  <button type="button" class="fallback__microsoft" (click)="goToStaffDoor()">
    <app-microsoft-mark [size]="18" />
    Continue with Microsoft
  </button>

  <p class="fallback__staff">Davaco staff only</p>
</app-auth-layout>
